// DO NOT EDIT -- generated from fs/services/search-settings/journeymaps.proto

import * as accesscontrol from '../../shared/accesscontrol';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';
import * as visualizationsettings from './visualizationsettings';

export namespace JourneyMaps {

  export const GetAllJourneyMapsEndpoint = "/grpc/search_settings.JourneyMaps/GetAllJourneyMaps";
  /**
   * Get all current non-archived journey maps for an org.
   * If desired, archived journey maps can also be retrieved with the explicit request flag.
   */
  export function GetAllJourneyMaps(sender: (req: GetAllJourneyMapsRequest, endpoint: string) => Promise<GetAllJourneyMapsResponse>, req: GetAllJourneyMapsRequest): { promise: () => Promise<GetAllJourneyMapsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllJourneyMapsEndpoint),
      endpoint: GetAllJourneyMapsEndpoint
    };
  }

  export const GetJourneyMapEndpoint = "/grpc/search_settings.JourneyMaps/GetJourneyMap";
  /** Get a specific journey map, either current or past version. */
  export function GetJourneyMap(sender: (req: GetJourneyMapRequest, endpoint: string) => Promise<GetJourneyMapResponse>, req: GetJourneyMapRequest): { promise: () => Promise<GetJourneyMapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetJourneyMapEndpoint),
      endpoint: GetJourneyMapEndpoint
    };
  }

  export const BatchGetJourneyMapsEndpoint = "/grpc/search_settings.JourneyMaps/BatchGetJourneyMaps";
  /** Get a specific set of journey maps, either current or past versions. */
  export function BatchGetJourneyMaps(sender: (req: BatchGetJourneyMapRequest, endpoint: string) => Promise<BatchGetJourneyMapResponse>, req: BatchGetJourneyMapRequest): { promise: () => Promise<BatchGetJourneyMapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetJourneyMapsEndpoint),
      endpoint: BatchGetJourneyMapsEndpoint
    };
  }

  export const SetJourneyMapEndpoint = "/grpc/search_settings.JourneyMaps/SetJourneyMap";
  /** Add a new journey map or update an existing journey map. */
  export function SetJourneyMap(sender: (req: SetJourneyMapRequest, endpoint: string) => Promise<SetJourneyMapResponse>, req: SetJourneyMapRequest): { promise: () => Promise<SetJourneyMapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetJourneyMapEndpoint),
      endpoint: SetJourneyMapEndpoint
    };
  }

  export const ArchiveJourneyMapEndpoint = "/grpc/search_settings.JourneyMaps/ArchiveJourneyMap";
  /**
   * Archive an existing journey map for an org.
   * Once archived, the journey map cannot be modified and will not show up in GetAllJourneyMaps unless explicitly requested.
   */
  export function ArchiveJourneyMap(sender: (req: ArchiveJourneyMapRequest, endpoint: string) => Promise<ArchiveJourneyMapResponse>, req: ArchiveJourneyMapRequest): { promise: () => Promise<ArchiveJourneyMapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveJourneyMapEndpoint),
      endpoint: ArchiveJourneyMapEndpoint
    };
  }

  export const UnarchiveJourneyMapEndpoint = "/grpc/search_settings.JourneyMaps/UnarchiveJourneyMap";
  /**
   * Unarchives an existing journey map for an org.
   * Once unarchived, the journey map can continue to be modified and will show up in GetAllJourneyMaps.
   */
  export function UnarchiveJourneyMap(sender: (req: UnarchiveJourneyMapRequest, endpoint: string) => Promise<UnarchiveJourneyMapResponse>, req: UnarchiveJourneyMapRequest): { promise: () => Promise<UnarchiveJourneyMapResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveJourneyMapEndpoint),
      endpoint: UnarchiveJourneyMapEndpoint
    };
  }

  export const GetJourneyMapsAccessEndpoint = "/grpc/search_settings.JourneyMaps/GetJourneyMapsAccess";
  export function GetJourneyMapsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetJourneyMapsAccessEndpoint),
      endpoint: GetJourneyMapsAccessEndpoint
    };
  }
}

export namespace JourneyMapsPublic {

  export const GetJourneyMapsAccessEndpoint = "/grpc/search_settings.JourneyMapsPublic/GetJourneyMapsAccess";
  export function GetJourneyMapsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetJourneyMapsAccessEndpoint),
      endpoint: GetJourneyMapsAccessEndpoint
    };
  }
}

export interface GetAllJourneyMapsRequest {
  orgId: string;
  /** If true, archived journey maps will also be returned. */
  includeArchived: boolean;
  /** By default, only public journeys are returned */
  includePrivate: boolean;
}

export interface GetAllJourneyMapsResponse {
  journeyMaps: JourneyMapRecord[];
}

export interface GetJourneyMapRequest {
  /** required */
  orgId: string;
  /** required */
  journeyMapId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
}

export interface GetJourneyMapResponse {
  versions: JourneyMapRecord[];
}

export interface BatchGetJourneyMapRequest {
  /** required */
  orgId: string;
  /** required */
  identifiers: BatchGetJourneyMapRequest.Identifier[];
  /** optional, max number of records to return for unspecified versions; defaults to a single record */
  limit: number;
}

export namespace BatchGetJourneyMapRequest {
  export interface Identifier {
    /** required */
    journeyMapId: string;
    /** optional. If not specified, the most recent [limit] versions will be returned. */
    version: protobuf.int64;
  }
}

export interface BatchGetJourneyMapResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found journey maps will still be represented with an empty versions result set.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetJourneyMapResponse.Result[];
}

export namespace BatchGetJourneyMapResponse {
  export interface Result {
    identifier: BatchGetJourneyMapRequest.Identifier | null;
    versions: JourneyMapRecord[];
  }
}

export interface SetJourneyMapRequest {
  orgId: string;
  /**
   * JourneyMap to be created or updated.
   * If the id field is not set, an id will be generated and a new journey map will be stored.
   */
  journeyMap: JourneyMap | null;
  visibility: protoauditstore.Visibility;
}

export interface SetJourneyMapResponse {
  journeyMap: JourneyMapRecord | null;
}

export interface ArchiveJourneyMapRequest {
  orgId: string;
  journeyMapId: string;
}

export interface ArchiveJourneyMapResponse {
  journeyMap: JourneyMapRecord | null;
}

export interface UnarchiveJourneyMapRequest {
  orgId: string;
  journeyMapId: string;
}

export interface UnarchiveJourneyMapResponse {
  journeyMap: JourneyMapRecord | null;
}

export interface JourneyMap {
  id: string;
  name: string;
  description: string;
  journeyMap: segment.JourneyMap | null;
  journeyMapSettings: visualizationsettings.JourneyMapSettings | null;
}

export interface JourneyMapRecord {
  journeyMap: JourneyMap | null;
  metadata: protoauditstore.AuditMetadata | null;
}
